import React, { FC } from 'react';
import { Text, Flex, Spinner, FlexProps } from '@chakra-ui/react';

interface LoadingProps extends FlexProps {
  text?: string;
}

const Loading: FC<LoadingProps> = ({ text, ...props }) => (
  <Flex justifyContent='center' alignItems='center' bg='transparent' h='100vh' {...props}>
    <Flex alignItems='center'>
      <Text colorScheme='brand' mr='3'>
        {text}
      </Text>
      <Spinner size='xl' colorScheme='brand' />
    </Flex>
  </Flex>
);

export default Loading;
